<template>
  <layout-view navTitle="Категории" :nav-loading="loadState.isLoading">
    <template v-slot:navBarActions>
      <v-btn small depressed @click="nomenCatCreateUpdate={id:null,name:null}" class="mt-n1">Создать</v-btn>
    </template>
    <template v-slot:nav>
      <v-list dense>
        <v-list-item-group v-model="nomenCatsIndex" mandatory>
          <v-list-item v-for="(item, i) in nomenCats" :key="i">
            <v-list-item-content>
              <v-list-item-title>{{item.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </template>
    <template v-if="nomenCats.length>0 && typeof nomenCatsIndex!=='undefined'" v-slot:content="{height}">
        <toolbar-view>
          <template v-slot:barActions>
            <v-btn small depressed @click="nomenCatCreateUpdate=nomenCats[nomenCatsIndex]" class="mr-2">Изменить категорию</v-btn>
            <btn-small-accept name="Удалить категорию" text="Будут отвязаны все услуги из номенклатуры и удалена вся номенклатура из категории. Удалить категорию?" @accept="nomenCatDelete(nomenCats[nomenCatsIndex].id)"/>
            <dot/>
            <v-btn small depressed @click="nomenCreateUpdate={id:null,name:null,code:null,nomenCat:nomenCats[nomenCatsIndex]}">Создать номенклатуру</v-btn>
          </template>
        </toolbar-view>

        <n-table-view
          v-if="nomenCats.length>0"
          ref="table"
          name="Номенклатура"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="[
            { text: 'ID', sortable: false},
            { text: 'Название', sortable: false},
            { text: 'Код по справочнику', sortable: false},
          ]"
        >
      
        <template v-slot:item="{ item }">
          <tr @click="nomenCreateUpdate=item">
            <td>{{item.id}}</td>
            <td class="text-wrap">{{item.name}}</td>
            <td>{{item.code}}</td>
          </tr>
        </template>
      </n-table-view>
    </template>
    <template v-slot:footer>
      <dialog-editor
          :name="nomenCatCreateUpdate===null || nomenCatCreateUpdate.id===null ? 'Создать категорию номенклатуры' : 'Редактировать категорию номенклатуры'"
          :item.sync="nomenCatCreateUpdate"
          @submit="nomenCatCreateUpdateAction"
      >
        <template v-slot:default="{localItem}">
          <text-field name="Название" :value.sync="localItem.name"/>
        </template>
      </dialog-editor>
      <dialog-editor
          :name="nomenCreateUpdate===null || nomenCreateUpdate.id===null ? 'Создать номенклатуру' : 'Редактировать номенклатуру'"
          :item.sync="nomenCreateUpdate"
          @submit="nomenCreateUpdateAction"
      >
        <template v-slot:default="{localItem}">
          <text-field name="Название" :value.sync="localItem.name" required/>
          <text-field name="Цена" :value.sync="localItem.price" after-icon="mdi-currency-rub" format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="1000 или 1000.10" required/>
          <text-field name="Код" :value.sync="localItem.code"/>
          <autocomplete-single name="Категория" :items="nomenCats" :select.sync="localItem.nomenCat" required />
        </template>
        <template v-if="nomenCreateUpdate!==null && nomenCreateUpdate.id!==null" v-slot:footerActions="{}">
          <btn-text-accept name="Удалить" text="Удалить?" color="error" @accept="nomenDelete(nomenCreateUpdate.id)"/>
        </template>
      </dialog-editor>
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import LayoutView from "@/components/LayoutView.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import BtnTextAccept from "@/componentsV2/base/BtnTextAccept.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import axios from "axios";
import Api from "@/Api";
import ToolbarView from "@/components/ToolbarView.vue";
import BtnSmallAccept from "@/componentsV2/base/BtnSmallAccept.vue";
import Dot from "@/componentsV2/base/Dot.vue";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import NTableView from "@/componentsV2/base/NTableView.vue";

import {
  Entity_Nomen,
  Entity_NomenCat,
} from "../../../EntityStoreCacheService";

export default {
  components: {
    AutocompleteSingle,
    Dot,
    BtnSmallAccept,
    ToolbarView,
    TextField,
    BtnTextAccept,
    DialogEditor, 
    LayoutView,
    NTableView
  },
  data: () => ({
    loadState: new State(),
    nomenCats: [],
    nomenCatsIndex:0,
    nomenCatCreateUpdate:{},


    nomenCreateUpdate:{},
    filter: {
      nomenCatId: null
    }
  }),
  mounted() {
    this.nomenCatsLoad();
  },
  watch:{
    nomenCatsIndex(){
      if(this.nomenCats.length>0)
        this.filter.nomenCatId = this.nomenCats[this.nomenCatsIndex].id
    },
    nomensOptions() {
      this.filter.nomenCatId = this.nomenCats[this.nomenCatsIndex].id
    },
    filter: {
      handler() {
          this.$refs.table?.load();
      },
      deep: true,
    },
  },
  methods:{
    nomenCatsLoad(){

    new Entity_NomenCat()
      .selects(Entity_NomenCat.id)
      .selects(Entity_NomenCat.name)
      .order(Entity_NomenCat.name, true)
      .page(null)
      .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
      .request((v)=>{
           this.nomenCats = v.items;
            if(this.nomenCats.length>0)
              this.filter.nomenCatId = this.nomenCats[0].id
      }, (e)=>{
        console.error(e.response.data.message);
      })  
    },
    nomenCatCreateUpdateAction(data){
      if(data.id===null){
        axios.post(Api.host+'/nomenCat/', data)
          .then(()=>{
            this.$store.commit('alertSuccess', 'Успешно создано')
            this.nomenCatCreateUpdate = null;
            this.nomenCatsLoad();
          })
          .catch(() => this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку'));
      } else {
        axios.put(Api.host+'/nomenCat/'+data.id+'/', data)
            .then(()=>{
              this.$store.commit('alertSuccess', 'Успешно изменено')
              this.nomenCatCreateUpdate = null;
              this.nomenCatsLoad();
            })
            .catch(() => this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку'));
      }
    },
    nomenCatDelete(id){
      axios.delete(Api.host+'/nomenCat/'+id+'/')
          .then(()=>{
            this.$store.commit('alertSuccess', 'Успешно удалено')
            this.nomenCatsIndex = 0;
            this.nomenCatsLoad();
          })
          .catch(() => this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку'));
    },
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_Nomen()
      .selects(Entity_Nomen.id)
      .selects(Entity_Nomen.name)
      .selects(Entity_Nomen.price)
      .selects(Entity_Nomen.code)
      .selects([Entity_Nomen.nomenCat, Entity_NomenCat.id].join('.'))
      .filterAnd([Entity_Nomen.entity, Entity_Nomen.nomenCat, Entity_NomenCat.id].join('.') + ' =?',this.filter.nomenCatId)

      rb.page(page).onPage(onPage)

      sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
      })

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v)
      })

      return rb;
    },
    nomenCreateUpdateAction(data){
      if(data.id===null){
        axios.post(Api.host+'/nomen/', data)
            .then(()=>{
              this.$store.commit('alertSuccess', 'Успешно создано')
              this.nomenCreateUpdate = null;
              this.filter.nomenCatId = data.nomenCat.id
            })
            .catch(() => this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку'));
      } else {
        axios.put(Api.host+'/nomen/'+data.id+'/', data)
            .then(()=>{
              this.$store.commit('alertSuccess', 'Успешно изменено')
              this.nomenCreateUpdate = null;
              this.filter.nomenCatId = data.nomenCat.id
            })
            .catch(() => this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку'));
      }
    },
    nomenDelete(id){
      axios.delete(Api.host+'/nomen/'+id+'/')
          .then(()=>{
            this.filter.nomenCatId = this.nomenCreateUpdate.nomenCat.id
            this.$store.commit('alertSuccess', 'Успешно удалено')
            this.nomenCreateUpdate = null;
          })
          .catch(() => this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку'));
    },
  }
}
</script>